var map = {
	"./Agriculture-and-Environmental-Sciences.jpg": 4436,
	"./Architecture-and-Design.jpg": 1366,
	"./Arts-and-Creative-Industries.jpg": 1347,
	"./Automotive-and-Mechanics.jpg": 9325,
	"./Aviation-and-Aerospace.jpg": 949,
	"./Business-and-Finance copy.jpg": 2244,
	"./Business-and-Finance.jpg": 7463,
	"./Culinary-Arts.jpg": 4442,
	"./Education-and-Academia.jpg": 5480,
	"./Education-and-training.jpg": 4629,
	"./Engineering copy.jpg": 9400,
	"./Engineering.jpg": 5579,
	"./Entertainment-and-Performing-Arts.jpg": 9519,
	"./Healthcae-and-medicine.jpg": 2048,
	"./Hospitality-and-Tourism.jpg": 7256,
	"./Language-and-Linguistics.jpg": 1083,
	"./Law-and-Legal-Services.jpg": 9961,
	"./Media-and-Communication.jpg": 4413,
	"./Military.jpg": 793,
	"./Physical-and -Sports-Sciences.jpg": 8607,
	"./Science-and-Research.jpg": 8884,
	"./Social-Media-and-Digital-Marketing.jpg": 8138,
	"./Social-Services.jpg": 952,
	"./Technology-and-It.jpg": 1718
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6102;